import { api } from "./api.js";

export const WORK_TYPE_COLORS = {
  premium: "bg-[#1F3864] text-white border-[#1F3864]",
  budget: "bg-amber-100 text-amber-900 border-amber-300",
  pdr: "bg-teal-100 text-teal-900 border-teal-300",
  polishing: "bg-pink-100 text-pink-900 border-pink-300",
  internal: "bg-slate-200 text-slate-800 border-slate-300",
  pdi: "bg-emerald-100 text-emerald-900 border-emerald-300",
};
export const WORK_TYPE_UNDEFINED = "bg-gray-100 text-gray-600 border-gray-300";

export const CATEGORY_LABELS = {
  quotation: "Cotação",
  repair_order: "Ordem de reparação",
  payment_proof: "Comprovativo de pagamento",
  additional_quote: "Orçamento adicional",
  photo: "Fotografia",
};

export async function uploadBpsFile(bpsId, file, category) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("record_type", "body_shop_case");
  fd.append("record_id", bpsId);
  fd.append("category", category);
  const { data } = await api.post("/attachments/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function openAttachment(att) {
  const res = await api.get(`/attachments/${att.id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// datetime-local value <-> ISO helpers
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);
